module.exports = __webpack_public_path__ + "img/264.657be138.jpg";